import React, { useState, useEffect } from "react";
import photoImg from '../../../public/img/photo.png';

const ProfilePage = () => {
    const [showEditPage, setShowEditPage] = useState(false);

    const [tempProfileData, setTempProfileData] = useState({
        firstName: '',
        lastName: '',
        middleName: '',
        dateBirth: '',
        email: '',
    });

    const [profileData, setProfileData] = useState({
        firstName: '',
        lastName: '',
        middleName: '',
        dateBirth: '',
        email: '',
    });

    const [loading, setLoading] = useState(true);

    const fetchProfileData = async () => {
        try {
            const response = await fetch('https://meetmind.ru/v1/spec/profile/get-general');
            if (response.ok) {
                const data = await response.json();
                setProfileData({
                    firstName: data.first_name,
                    lastName: data.second_name,
                    middleName: data.middle_name,
                    dateBirth: data.birthday,
                    email: data.email,
                });
            } else {
                console.error('Failed to fetch about data');
            }
        } catch (error) {
            console.error('Error fetching about data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfileData();
    }, []);

    const handleEditPage = (e) => {
        e.preventDefault();
        if (showEditPage) {
            setTempProfileData({
                firstName: '',
                lastName: '',
                middleName: '',
                dateBirth: '',
                email: '',
            });
        } else {
            setTempProfileData(profileData);
        }
        setShowEditPage(!showEditPage);
    };

    const sanitizeTextInput = (e) => {
        const { name, value } = e.target;

        setTempProfileData((prevData) => ({
            ...prevData,
            [name]: value.replace(/[<>"'&]/g, ''),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log(JSON.stringify({ tempProfileData }));

            const response = await fetch('https://meetmind.ru/v1/spec/profile/set-general', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "profile": {
                    "email": tempProfileData.email,
                    "birthday": tempProfileData.dateBirth,
                    "first_name": tempProfileData.firstName,
                    "second_name": tempProfileData.lastName,
                    "middle_name": tempProfileData.middleName,
                } }),
                credentials: 'include',
            });

            if (response.ok) {
                console.log('Data saved successfully');

                fetchProfileData();

                setShowEditPage(false);
            } else {
                console.error('Failed to save about data');
            }
        } catch (error) {
            console.error('Error saving about data:', error);
        }
    };

    return (
        <div className="profile">
            {!showEditPage ? (
                <div className="profile__body">
                    <div className="profile__header">
                        <div className="profile__title">Профиль</div>
                        <div className="profile__controller" onClick={handleEditPage}>
                            <i className="fa-solid fa-pen-to-square"></i>
                        </div>
                    </div>
                    <div className="profile__content">
                        <div className="profile__row">
                            <div className="profile__column">
                                <div className="profile__photo">
                                    <img src={photoImg} alt="Person" />
                                </div>
                                <button className="profile__button button">Загрузить фото</button>
                            </div>
                            <div className="profile__info">
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Фамилия
                                        <input className="profile__input input" type="text" disabled value={profileData.lastName} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Имя
                                        <input className="profile__input input" type="text" disabled value={profileData.firstName} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Отчество
                                        <input className="profile__input input" type="text" disabled value={profileData.middleName} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Дата рождения
                                        <input className="profile__input input" type="date" disabled value={profileData.dateBirth} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Адрес электронной почты
                                        <input className="profile__input input" type="text" disabled value={profileData.email} />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="profile__body">
                    <div className="profile__header">
                        <div className="profile__title">Профиль</div>
                        <div className="profile__controller" onClick={handleEditPage}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                    </div>
                    <div className="profile__content">
                        <div className="profile__row">
                            <div className="profile__column">
                                <div className="profile__photo">
                                    <img src={photoImg} alt="Person" />
                                </div>
                                <button className="profile__button button">Загрузить фото</button>
                            </div>
                            <div className="profile__info">
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Фамилия *
                                        <input className="profile__input input" type="text" placeholder="Иванов" maxLength={25} name="lastName" value={tempProfileData.lastName} onChange={sanitizeTextInput} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Имя *
                                        <input className="profile__input input" type="text" placeholder="Иван" maxLength={25} name="firstName" value={tempProfileData.firstName} onChange={sanitizeTextInput} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Отчество
                                        <input className="profile__input input" type="text" placeholder="Иванович" maxLength={25} name="middleName" value={tempProfileData.middleName} onChange={sanitizeTextInput} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Дата рождения *
                                        <input className="profile__input input" type="date" name="dateBirth" value={tempProfileData.dateBirth} onChange={sanitizeTextInput} />
                                    </label>
                                </div>
                                <div className="profile__field">
                                    <label className="profile__label label">
                                        Адрес электронной почты
                                        <input className="profile__input input" type="email" placeholder="example@meetmind.ru" maxLength={25} name="email" value={tempProfileData.email} onChange={sanitizeTextInput} />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="profile__actions">
                        <button className="profile__button button" onClick={handleSubmit}>Сохранить изменения</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfilePage;
